import { State } from './State';

export interface ClientAddress {
  id: number;
  typeId: number | null;
  clientId: number | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  stateId: number | null;
  zip: string | null;
  country: string | null;
  isPrimary: boolean | null;

  state: State | null;
}

export enum ClientAddressTypeEnum {
  Billing = 1,
  Shipping = 2,
}
